






































































































































































import { Component, Vue } from 'vue-property-decorator';

import axios from 'axios';

import CreateEditUserGroupModal from '@/components/CreateEditUserGroupModal.vue';
import { Company, DataFilter, DataFilterOption, User, UserGroup } from '@/lib/models';

@Component({
  components: {
    CreateEditUserGroupModal,
  },
})
export default class UserGroups extends Vue {
  private userGroupToEdit: UserGroup | null = null;

  private isLoading: boolean = false;
  private currentPage: number = 1;
  private totalRows: number = 0;
  private pageOptions: number[] = [5, 10, 15, 20];
  private perPage: number = 10;

  private userGroupFields: any[] = [
    {
      key: 'name',
      sortable: true,
    },
    {
      key: 'description',
      sortable: true,
    },
    {
      key: 'actions',
      sortable: false,
    },
  ];

  private userGroupFilter: any = {
    name: '',
    description: '',
  };

  private async userGroupProvider(context: any): Promise<UserGroup[]> {
    let url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/usergroups?limit=${context.perPage}&page=${context.currentPage}`;

    if (context.sortBy !== '') {
      url += `&sort=${context.sortBy}:${context.sortDesc ? 'desc' : 'asc'}`;
    }

    if (context.filter.name !== '') {
      url += `&name=${encodeURIComponent(context.filter.name)}`;
    }

    if (context.filter.description !== '') {
      url += `&description=${encodeURIComponent(context.filter.description)}`;
    }

    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    this.isLoading = true;
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      const items = response.data.data;
      for (const item of items) {
        item._showDetails = false;
      }
      this.totalRows = response.data.meta.total;
      return items || [];
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Getting User Groups',
        okVariant: 'danger',
        centered: true,
      }).then(() => {
        return [];
      });
    }).finally(() => {
      this.isLoading = false;
    });
  }

  private showCreateUserGroupModal(): void {
    this.userGroupToEdit = null;
    this.$bvModal.show('create-edit-user-group-modal');
  }

  private showEditUserGroupModal(userGroup: UserGroup): void {
    this.userGroupToEdit = userGroup;
    this.$bvModal.show('create-edit-user-group-modal');
  }

  private refreshUserGroupTable(): void {
    (this.$refs.userGroupTable as any).refresh();
  }

  private confirmDeleteUserGroup(userGroup: UserGroup): void {
    this.$bvModal.msgBoxConfirm(`Please confirm that you want to delete the user group: ${userGroup.name}`, {
      title: 'Delete User Group',
      okVariant: 'danger',
      okTitle: 'Delete',
      centered: true,
      autoFocusButton: 'cancel',
      noCloseOnBackdrop: true,
    }).then((deleteUserGroup: boolean) => {
      if (deleteUserGroup) {
        this.deleteUserGroup(userGroup);
      }
    });
  }

  private async deleteUserGroup(userGroup: UserGroup): Promise<void> {
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/usergroups/${userGroup.id}`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    axios.delete(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      const message: string = `Successfully deleted user group: ${userGroup.name}`;
      this.$bvModal.msgBoxOk(message, {
        title: 'User Group Deleted',
        okVariant: 'success',
        centered: true,
      }).then(() => {
        this.refreshUserGroupTable();
      });
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Deleting User Group',
        okVariant: 'danger',
        centered: true,
      }).then(() => {
        this.refreshUserGroupTable();
      });
    });
  }
}
